import axios from "axios";
import { startLoading, updateLoading, endLoading } from "../utils/globalLoading";
import Cookies from "js-cookie"; // Install jika belum: npm install js-cookie
import { logout } from "../redux/authSlice";
import store from "./store"; // <- ✅ sesuaikan path jika beda
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";


//const apiUrl = "https://api.mantradxp.com";

const apiUrl = import.meta.env.VITE_API_URL;

// ✅ Konfigurasi dasar axios
const api = axios.create({
  baseURL: apiUrl, // Ganti dengan URL backend Laravel
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true, // ✅ Wajib untuk CSRF Protection!
});

// ✅ Fungsi untuk mengambil CSRF token sebelum mengirim request
export const getCsrfToken = async () => {
  try {
    await api.get("/sanctum/csrf-cookie"); // Ambil CSRF token dari Laravel
  } catch (error) {
    console.error("❌ Gagal mendapatkan CSRF token:", error.response?.data || error.message);
  }
};

// Uploads and downloads show the centre-screen overlay (utils/globalLoading)
// instead of a spinner on whichever button started them. Detected here so every
// caller — pages, hooks, Redux slices — gets it without its own loading UI.
// Opt out per request with { globalLoading: false }.
const UPLOAD_URL = /submit-(excel|json)|\/upload\b|\/import\b/i;
const DOWNLOAD_URL = /export|download|\/pdf\b|\.pdf\b/i;

const loadingKind = (config) => {
  if (config.globalLoading === false) return null;
  const url = config.url || '';
  if (config.data instanceof FormData || UPLOAD_URL.test(url)) return 'upload';
  if (['blob', 'arraybuffer'].includes(config.responseType) || DOWNLOAD_URL.test(url)) return 'download';
  return null;
};

const withLoadingOverlay = (config) => {
  const kind = loadingKind(config);
  if (!kind) return config;

  const id = startLoading(kind === 'upload' ? 'Uploading file…' : 'Preparing download…');
  config._loadingId = id;

  const onUpload = config.onUploadProgress;
  config.onUploadProgress = (event) => {
    if (kind === 'upload' && event.total) {
      const pct = Math.round((event.loaded / event.total) * 100);
      updateLoading(id, pct >= 100
        ? { message: 'Processing on the server… this can take a while for large files.', progress: null }
        : { message: 'Uploading file…', progress: pct });
    }
    if (onUpload) onUpload(event);
  };

  const onDownload = config.onDownloadProgress;
  config.onDownloadProgress = (event) => {
    if (kind === 'download') {
      updateLoading(id, {
        message: 'Downloading…',
        progress: event.total ? Math.round((event.loaded / event.total) * 100) : null,
      });
    }
    if (onDownload) onDownload(event);
  };
  return config;
};

const finishLoading = (config) => {
  if (config && config._loadingId) endLoading(config._loadingId);
};

// ✅ Tambahkan Bearer Token otomatis ke setiap request
api.interceptors.request.use(
  async (config) => {
    withLoadingOverlay(config);

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }


    const csrfToken = Cookies.get('XSRF-TOKEN'); // The cookie's name from Sanctum
    if (csrfToken) {
      config.headers['X-CSRF-TOKEN'] = csrfToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => {
    finishLoading(response.config);
    if (!response.data || typeof response.data !== 'object') {
      throw new Error('Invalid or non-object response data.');
    }
    return response;
  },
  async (error) => {
    finishLoading(error.config);
    if (error.response) {
      const { status, data } = error.response;
    

      // Cek jika token sudah kedaluwarsa
      // A 401 from the LOGIN call itself means "wrong credentials", not "your
      // session expired". Redirecting there reloads the page and wipes the error
      // the form just set, so the user sees the page blink and no explanation.
      // Let those bubble up to the form; only redirect for an expired session.
      const requestUrl = error.response.config?.url || '';
      const isLoginAttempt =
        requestUrl.includes('/authentications') &&
        (error.response.config?.method || '').toLowerCase() === 'post';

      if (status === 401 && !isLoginAttempt) {
        try {
          store.dispatch(logout());
          window.location.href = "/auth/login";
        } catch (error) {
          console.log(error)
        }
      }
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Axios Setup Error:', error.message);
    }

    return Promise.reject(error);
  }
);


export default api;
